import { RG_TECH_CLASS as _, RG_TYPE as F } from "@project-rouge/rg-core";
const p = {
  apartments: {
    "Scarlet 100_1B2Pv1": ["#D06381", 1],
    "Scarlet 101_1B2Pv2": ["#F57EB6", 1],
    "Scarlet 200_2B3Pv1": ["#4D9CDD", 1],
    "Scarlet 202_2B3Pv2": ["#00A9E0", 1],
    "Scarlet 201_2B4Pv1": ["#4DB58E", 1],
    "Scarlet 300_3B5Pv1": ["#FFD87D", 1],
    "Scarlet 301_3B6Pv1": ["#FF9562", 1],
    "UNT-01_1b1p_01s": ["#F57EB6", 1],
    "UNT-01_1b1p_01h": ["#F57EB6", 1],
    "UNT-01_1b2p_01s": ["#D06381", 1],
    "UNT-01_1b2p_01h": ["#D06381", 1],
    "UNT-01_1b2p_02s": ["#D06381", 1],
    "UNT-01_1b2p_02h": ["#D06381", 1],
    "UNT-01_1b2p_03s": ["#D06381", 1],
    "UNT-01_1b2p_03h": ["#D06381", 1],
    "UNT-01_1b2p_04s": ["#D06381", 1],
    "UNT-01_1b2p_04h": ["#D06381", 1],
    "UNT-01_2b3p_01s": ["#4D9CDD", 1],
    "UNT-01_2b3p_01h": ["#4D9CDD", 1],
    "UNT-01_2b4p_01s": ["#4DB58E", 1],
    "UNT-01_2b4p_01h": ["#4DB58E", 1],
    "UNT-01_2b4p_02s": ["#4DB58E", 1],
    "UNT-01_2b4p_02h": ["#4DB58E", 1],
    "UNT-01_2b4p_03s": ["#4DB58E", 1],
    "UNT-01_2b4p_03h": ["#4DB58E", 1],
    "UNT-01_2b4p_04s": ["#4DB58E", 1],
    "UNT-01_2b4p_04h": ["#4DB58E", 1],
    "UNT-01_3b5p_01s": ["#FFD87D", 1],
    "UNT-01_3b5p_01h": ["#FFD87D", 1],
    "UNT-01_3b5p_02s": ["#FFD87D", 1],
    "UNT-01_3b5p_02h": ["#FFD87D", 1],
    "UNT-01_3b6p_01s": ["#FF9562", 1],
    "UNT-01_3b6p_01h": ["#FF9562", 1],
    "UNT-01_3b6p_02s": ["#FF9562", 1],
    "UNT-01_3b6p_02h": ["#FF9562", 1]
  },
  techSpaces: {
    [_.Amenity]: ["#E0E0CD", 1],
    [_.Service]: ["#A9B5B4", 1]
  },
  rgTypes: {
    [F.World]: ["#FFFFFF", 1],
    [F.Site]: ["#FFFFFF", 1],
    [F.Zone]: ["#FFFFFF", 1],
    [F.Plot]: ["#FFFFFF", 1],
    [F.Building]: ["#FFFFFF", 1],
    [F.Entrance]: ["#C2C2D3", 1],
    [F.Core]: ["#AAAAAA", 1],
    [F.Corridor]: ["#EAEAEA", 1],
    [F.Apartment]: ["#FFFFFF", 1],
    [F.Module]: ["#FFFFFF", 1],
    [F.Balcony]: ["#FFFFFF", 1],
    [F.Roof]: ["#ECECEC", 1],
    [F.Wall]: ["#E6E0C8", 1],
    [F.Facade]: ["#C3B9AD", 1],
    [F.Floor]: ["#5A6772", 1],
    [F.Ceiling]: ["#5EA0BB", 1],
    [F.Column]: ["#8E3939", 1],
    [F.Beam]: ["#8E3939", 1],
    [F.Window]: ["#4B5E82", 0.8],
    [F.Door]: ["#564C83", 0.5],
    [F.TechnicalSpace]: ["#FFFFFF", 1],
    [F.TechnicalSpaceRoom]: ["#FFFFFF", 1],
    [F.Room]: ["#FFFFFF", 1],
    [F.Opening]: ["#FFFFFF", 1],
    [F.Parapet]: ["#BABABA", 1],
    [F.EmptySpace]: ["#C1B2AC", 1],
    [F.Glazing]: ["#4B5E82", 0.8]
  }
};
export {
  p as ColorsUkV1V2
};
//# sourceMappingURL=index.js.map
